export default __webpack_public_path__ + "static/media/90.89b9263a.png";